export const SITE_MAX_WIDTH = "1166px";
